import React, {useState, useContext} from 'react';
import Section from './UI/Section';
import LabelAndInput from './UI/LabelAndInput';
import {Context} from '../context';
import Button from './UI/Button';
import {logger} from '../helperFunctions';

function ForgotPassword() {
  const {localeText, forgotPassword: forgotPasswordAPI} = useContext(Context);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const submitHandler = e => {
    e.preventDefault();
    forgotPasswordAPI(email).then(ret => {
      logger(ret);
      setSubmitted(true);
    });
  };

  return (
    <Section
      sectionId='forgot-password'
      heading={localeText('rw_header_reset_password', 'Reset Password')}
      className='h-full'
    >
      {!submitted ? (
        <form action='' className='w-96' onSubmit={submitHandler}>
          <p>
            Please enter your email to request password <b>reset</b>
          </p>
          <LabelAndInput
            name='email'
            label={localeText('rw_title_email', 'Email')}
            type='email'
            placeholder={localeText('rw_title_email_placeholder', 'Email')}
            className='w-full'
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <Button className='w-full mt-6 bg-red hover:text-white' type='submit'>
            Reset Password
          </Button>
        </form>
      ) : (
        <div className='w-full h-full flex justify-center items-center'>
          <p className='text-center text-2xl text-green-600'>
            Please check your email to complete the password reset process.
          </p>
        </div>
      )}
    </Section>
  );
}

export default ForgotPassword;
